(function() {
  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function whenSlickReady(callback, attempt) {
    var currentAttempt = attempt || 0;
    if (window.jQuery && $.fn && typeof $.fn.slick === 'function') {
      callback();
      return;
    }
    if (currentAttempt > 40) return;
    setTimeout(function() {
      whenSlickReady(callback, currentAttempt + 1);
    }, 150);
  }

  function initVideos(section, tabletBreakpoint) {
    var videosLoaded = false;
    var sectionOffset = $(section).offset();
    if (!sectionOffset) return;

    var loadVideos = function() {
      var startLoadingVideos = sectionOffset.top - window.innerHeight;
      if ($(window).scrollTop() < startLoadingVideos || videosLoaded) return;

      var video = null;
      if (window.innerWidth > tabletBreakpoint) {
        video = section.querySelector('.video.desktop');
      } else {
        video = section.querySelector('.video.mobile');
      }

      if (!video) {
        videosLoaded = true;
        return;
      }

      if (!video.classList.contains('initialized')) {
        var source = video.querySelector('source');
        if (source && source.dataset.src) {
          source.setAttribute('src', source.dataset.src);
        }
        video.classList.add('initialized');

        setTimeout(function() {
          video.load();
        }, 100);

        
        var removeTimeout = false;
        video.addEventListener('canplay', function() {
          removeTimeout = setTimeout(function() {
            $(video).remove();
          }, 50);
        });
        video.addEventListener('playing', function() {
          clearTimeout(removeTimeout);
        });
        
      }

      videosLoaded = true;
    };

    loadVideos();
    if ($.throttle) {
      $(window).on('scroll', $.throttle(15, loadVideos));
    } else {
      $(window).on('scroll', loadVideos);
    }
    $(window).on('mediaChange', function() {
      videosLoaded = false;
      loadVideos();
    });
  }

  function initSection(section) {
    var carousel = section.querySelector('.carousel');
    if (!carousel) return;
    if ($(carousel).hasClass('slick-initialized')) return;

    var tabletBreakpoint = toNumber(section.dataset.breakpointTablet, 800);
    var autoplay = toBoolean(section.dataset.autoplay);
    var autoplayMobile = toBoolean(section.dataset.autoplayMobile);
    var autoplaySpeed = toNumber(section.dataset.autoplaySpeed, 3000);
    var blocksSize = toNumber(section.dataset.blocksSize, 1);

    if (section.querySelector('.video.desktop, .video.mobile')) {
      initVideos(section, tabletBreakpoint);
    }

    $(carousel).slick({
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      speed: 700,
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $(section).find('.custom-left-arrow'),
      nextArrow: $(section).find('.custom-right-arrow'),
      responsive: [
        {
          breakpoint: tabletBreakpoint,
          settings: {
            autoplay: autoplayMobile,
            arrows: false,
            speed: 500
          }
        }
      ]
    });

    $(carousel).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
      var nextSlideVideo = section.querySelector('.carousel .item[data-slick-index="' + nextSlide + '"] video');
      if (nextSlide === blocksSize - 1) {
        $(section).find('.button').fadeIn();
      }

      $(carousel)
        .find('video')
        .each(function() {
          this.pause();
        });

      if (nextSlideVideo) {
        nextSlideVideo.play();
      }

      $(section).find('.controls .number span').text(nextSlide + 1);
    });
  }

  $(function() {
    whenSlickReady(function() {
      document
        .querySelectorAll('.how-it-works[data-section-type="how-it-works"]')
        .forEach(initSection);
    });
  });
})();
